import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: ``
})
export class AppFooter {}
